import React, { useState, useEffect } from 'react';
import { Box, Stack, Grid, Typography, Container } from '@mui/material';
import { makeStyles } from '@mui/styles';
import SubjectIcon from '@mui/icons-material/Subject';
import { NavLink, useLocation, useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { footerData } from '../../../DATA/DataText';

const useStyles = makeStyles((theme) => ({
  Copyright: {
    backgroundColor: '#f27474',
    padding: '20px',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    '& h6': {
      fontSize: '13px',
      fontWeight: 400,
      color: 'white',
      textDecoration: 'none',
      letterSpacing: '1px',
      fontFamily: 'Reem Kufi, sans-serif'
    },
    '@media (max-width:500px)': {
      flexDirection: 'column'
    }
  },
  GridFooter: {
    backgroundColor: '#f27474',
    padding: '70px 3%',
    paddingTop: 20,
    display: 'flex',
    justifyContent: 'center'
  },
  gridContainer: {
    display: 'flex',
    '@media (max-width:900px)': {
      justifyContent: 'center'
    }
  },
  GridItemFooter: {
    padding: '15px',
    minWidth: 200,
    '& h6': {
      fontWeight: 600,
      color: 'white',
      textTransform: 'capitalize',
      textDecoration: 'none',
      fontSize: '19px',
      fontFamily: 'Oregano, cursive'
    }
  },
  Link: {
    fontSize: '15px',
    fontWeight: 400,
    color: 'white',
    textDecoration: 'none',
    fontFamily: 'Oregano, cursive'
  },
  LogoContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '@media (max-width:900px)': {
      width: '100%',
      alignItems: 'center',
      marginBottom: 20
    }
  },
  Logo: {
    color: 'white',
    fontSize: '30px',
    fontWeight: 600,
    textDecoration: 'none',
    letterSpacing: '1px',
    fontFamily: 'Reem Kufi, sans-serif'
  },
  imgRating: {
    height: 120,
    width: 120,
    objectFit: 'contain'
  },
  Icon: {
    color: 'black',
    '&:hover': {
      color: 'green'
    }
  },
  getAppImage: {
    backgroundColor: 'white',
    marginTop: 20,
    borderRadius: 10,
    width: '130px',
    height: '45px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& a img': {
      width: '130px',
      height: '50px',
      objectFit: 'contain'
    }
  }
}));

export default function Footer() {
  const classes = useStyles();
  const [t, i18n] = useTranslation();

  return (
    <>
      <div style={{ marginBottom: -10 }}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path
            fill="#f27474"
            fillOpacity="1"
            height={200}
            width="100%"
            d="M0,192L80,202.7C160,213,320,235,480,213.3C640,192,800,128,960,106.7C1120,85,1280,107,1360,117.3L1440,128L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"
          />
        </svg>
      </div>
      <Grid style={{ backgroundColor: '#f27474' }}>
        <Container>
          <Grid xs={12} container className={classes.GridFooter}>
            <Grid item xs={12} md={3} sm={12}>
              <div className={classes.LogoContainer}>
                <img alt="img" src="/static/logo/logoV.png" className={classes.imgRating} />
              </div>
            </Grid>
            {footerData.map((row) => (
              <Grid item xs={12} sm={6} md={3} className={classes.gridContainer}>
                <div className={classes.GridItemFooter}>
                  <div>
                    <h6>{t(row.title)}</h6>
                  </div>
                  {row.children.map((index) => (
                    <Box style={{ marginTop: '10px' }}>
                      <Link to={index.path} className={classes.Link}>
                        {t(index.title)}
                      </Link>
                    </Box>
                  ))}
                </div>
              </Grid>
            ))}
            <Grid item xs={12} sm={6} md={3} className={classes.gridContainer}>
              <div className={classes.GridItemFooter}>
                <div>
                  <h6>{t('applicationmobile')}</h6>
                </div>
                <div className={classes.getAppImage}>
                  <a href="#">
                    <img alt="img" src="/static/payment/p7.png" />
                  </a>
                </div>
                <div className={classes.getAppImage}>
                  <a href="#">
                    <img alt="img" src="/static/payment/p6.png" />
                  </a>
                </div>
              </div>
            </Grid>
          </Grid>
          <Grid container xs={12} sm={12} className={classes.Copyright}>
            <h6>© 2026 SmileLand Website</h6>
            <div style={{ margin: '5px' }}>
              <Link to="/mentions-legales" className={classes.Link}>
                {t('mention')}
              </Link>
            </div>
            <div style={{ margin: '5px' }}>
              <Link to="/privacy" className={classes.Link}>
                {t('PolitiqueConfidentialité')}
              </Link>
            </div>
            <div style={{ margin: '5px' }}>
              <Link to="/cookies" className={classes.Link}>
                {t('PolitiquedeCookies')}
              </Link>
            </div>
          </Grid>
        </Container>
      </Grid>
    </>
  );
}
